import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive } from 'vue';
import Title from '../title/index.vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Desc'
  },
  __name: 'desc',
  setup(__props, {
    expose: __expose
  }) {
    const formData = reactive({
      desc: '',
      pure: false,
      version: '3'
    });
    __expose({
      formData
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Title, {
        title: "音乐/歌词说明",
        desc: "描述您想要的音乐风格和主题，使用流派和氛围而不是特定的艺术家和歌曲"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.desc,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.desc = $event),
          autosize: {
            minRows: 6,
            maxRows: 6
          },
          resize: "none",
          type: "textarea",
          maxlength: "1200",
          "show-word-limit": "",
          placeholder: "一首关于糟糕分手的欢快歌曲"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(Title, {
        title: "纯音乐",
        desc: "创建一首没有歌词的歌曲"
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: formData.pure,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.pure = $event),
          size: "small"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(Title, {
        title: "版本",
        desc: "描述您想要的音乐风格和主题，使用流派和氛围而不是特定的艺术家和歌曲"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: formData.version,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.version = $event),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            value: '3',
            label: 'V3'
          }, {
            value: '2',
            label: 'V2'
          }], item => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
});